"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.useTheme = exports.ThemeConsumer = exports.ThemeContext = exports.useColor = exports.AckoMainTheme = void 0;
var Acko_1 = require("./themes/Acko");
Object.defineProperty(exports, "AckoMainTheme", { enumerable: true, get: function () { return Acko_1.AckoMainTheme; } });
var ThemeProviders_1 = require("./ThemeProviders");
Object.defineProperty(exports, "useColor", { enumerable: true, get: function () { return ThemeProviders_1.useColor; } });
Object.defineProperty(exports, "ThemeContext", { enumerable: true, get: function () { return ThemeProviders_1.ThemeContext; } });
Object.defineProperty(exports, "ThemeConsumer", { enumerable: true, get: function () { return ThemeProviders_1.ThemeConsumer; } });
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return ThemeProviders_1.useTheme; } });
var ThemeProviders_2 = require("./ThemeProviders");
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return __importDefault(ThemeProviders_2).default; } });
//# sourceMappingURL=index.js.map